import axios from "axios"

const initialState = {
  view: null,
  records: null,
  customerRecords: null,
  customer: null,
  items: null,
  loading: false,
  tmList: null,
  selectedTm: null
}

export const displayTrackingStore = {
  state: {...initialState},
  mutations:{
    setRecords(state, data){
      state.records = data.records
    },
    setView(state, view){
      state.view = view
    },
    setCustomer(state, customer){
      state.customer = customer
    },
    setCustomerRecords(state, data){
      state.customerRecords = data.records
    },
    updateCustomerRecords(state, data){
      const transaction = data.transaction
      const keys = ['customerRecords', 'records']
      keys.forEach((k)=>{
        state[k] = _.reject(state[k], (r) =>{
          return r.customer_id == transaction.customerID && r.merchandisingItemId == transaction.merchandisingItemId
        })
      })
    },
    setItems(state, data){
      state.items = data.items
    },
    setLoading(state, status){
      state.loading = status
    },
    setTmList(state, tmList){
      state.tmList = tmList
    },
    setSelectedTm(state, tm){
      state.selectedTm = tm
      if(tm) state.view = 'index'
    }
  },
  actions:{
    // Get all merchandising data assigned to eclipse user ID
    displayTrackingGetRepRecords(context, username){
      const params = {username}
      axios.get('/api/v1/private/display_tracking/get_rep_records', {params})
      .then(res=>{
        context.commit('setRecords', res.data)
        context.commit('setView', 'index')
      })
      .catch(error=>{
        console.error("Error:", error);
      })
    },
    // Set view for sub areas of display tracking front end
    displayTrackingSetView(context, view){
      context.commit('setView', view)
    },
    // Set active customer
    displayTrackingSetCustomer(context, customer){
      context.commit('setCustomer', customer)
      context.commit('setView', 'detail')
    },
    // Get singular customer records
    displayTrackingGetCustomerRecords(context, customerID){
      context.commit('setLoading', true)
      const params = {customer_id: customerID}
      axios.get('/api/v1/private/display_tracking/get_customer_records', {params})
      .then(res=>{
        context.commit('setCustomerRecords', res.data)
        context.commit('setLoading', false)
      })
      .catch(error=>{
        console.error("Error:", error);
      })
    },
    // Get all available merchandising items
    displayTrackingGetItems(context){
      axios.get('/api/v1/private/display_tracking/get_merchandising_items')
      .then(res=>{
        context.commit('setItems', res.data)
      })
      .catch(error=>{
        console.error("Error:", error);
      })
    },
    // Assign merchandising item to customer
    displayTrackingTransaction(context, data){
      const params = {
        username: this.state.sessionStore.user.username,
        qty: data.qty,
        customerId: data.customer.id,
        merchandisingItemId: data.item.id,
        reason: data.qty > 0 ? 'Assign to customer' : data.reason
      }
      axios.post('/api/v1/private/display_tracking/send_merchandising_transactions', params)
      .then(res=>{
        if(data.qty > 0){
          this.dispatch('displayTrackingGetCustomerRecords', res.data.transaction.customerId)
        }else{
          context.commit('updateCustomerRecords', res.data)
        }
      })
      .catch(error=>{
        console.error("Error:", error);
      })
    },
    // Get list of TM's for Manager Access
    displayTrackingTmList(context){
      context.commit('setLoading', true)
      axios.get('/api/v1/private/tm/tm_list')
      .then(function(res){
        context.commit('setTmList', res.data.tm_list)
        context.commit('setLoading', false)
      })
      .catch(error=>{
        console.error("Error:", error);
      })
    },
    displayTrackingSetSelectedTm(context, tm){
      context.commit('setSelectedTm', tm)
    },
    displayTrackingSetLoading(context, status){
      context.commit('setLoading', status)
    }
  },
  getters:{
    displayTrackingRecords: state => {return state.records},
    displayTrackingView: state => {return state.view},
    displayTrackingCustomer: state => {return state.customer},
    displayTrackingCustomerRecords: state => {return state.customerRecords},
    displayTrackingItems: state =>{return state.items},
    displayTrackingLoading: state => {return state.loading},
    displayTrackingTmList: state => {return state.tmList},
    displayTrackingSelectedTm: state => {return state.selectedTm}
  }
}